import React from 'react';
import IndexedDBService from '../Services/IndexedDBService';

export type IndexedDBContextProps = {
    indexedDBService: IndexedDBService,
};

const IndexedDBContext: React.Context<IndexedDBContextProps> = React.createContext<IndexedDBContextProps>({
    indexedDBService: new IndexedDBService('experience'),
});

export default IndexedDBContext;